import { useEffect } from "react";
import { Preview } from "./Preview";
import { AddMasteredVersionProps } from "./types";
import { hideVolumeControl } from "../../utils/DolbyIoUtils";

export const CreateVersion: React.FC<AddMasteredVersionProps> = ({
  track,
  masteredMusicUrl,
  state,
  loading,
  handleAccessStage,
}) => {
  useEffect(() => {
    hideVolumeControl();
    handleAccessStage(4);
  }, [handleAccessStage]);

  return (
    <Preview
      track={track}
      masteredMusicUrl={masteredMusicUrl}
      previewUrl={undefined}
      selectedPresetArray={[]}
      setSelectedPresetValue={() => {}}
      loading={loading}
      previewState={state}
      previewStartValue={undefined}
      duration={undefined}
    />
  );
};
